// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".part-selected .el-checkbox__inner{background-color:#dcdfe6!important;border-color:#dcdfe6!important}", ""]);
// Exports
module.exports = exports;
